export default __webpack_public_path__ + "static/media/manage-admin.ec4205e8.svg";